// extracted by mini-css-extract-plugin
module.exports = {"dialog":"ConfirmationDialog_dialog__2mobT"};